import React, { useState } from "react";
import { ExtraDisambInfos } from "./index";
import AccountBalance from "../WorkFlows/AccountBalance";
import AccountSummary from "../WorkFlows/AccountSummary";
import MiniStatementDetails from "../WorkFlows/MiniStatement";
import CreditCardMiniStatementDetails from "../WorkFlows/CreditCardMiniStatementDetails";
import CreditCardStatement, {
  LastPaymentStatement,
  CreditCardGetTotalCreditLimit,
  CreditCardGetAvailableCreditLimit,
  StatementDetailForLastPayment,
  StatementDetailForStatementCycle,
  StatementDetailForOutstanding,
  StatementDetailForMinAmoutDue,
  StatementDetailForPaymentDetails,
} from "../WorkFlows/CreditCardStatement";
import CreditCardTransactionDetails from "../WorkFlows/CCTransactionDetails";
import TransactionHistoryDetails from "../WorkFlows/TransactionHistory";
import CheckBox from "../../FeatureComponents/WorkFlows/CheckBox";
import { downloadPDFData } from "../WorkFlows/DownloadPdf";
import IFSCSelector, {
  BillerRegion,
  BillerName,
  LocationList,
  BillerAccount,
  BillPaymentSummary,
  NomineeRelation,
  NomineeCountry,
  NomineeState,
  NomineeCity,
  GuardianCode,
  LeadGenStates,
  LeadGenCities,
  Turnover,
  LeadGenCountries,
  CreditCardRewards,
  CreditCardOrderId,
  HomeLoanCity,
  CreditCardBillingCycle,
} from "../WorkFlows/IFSCSelector";

import MobileRechargePlan from "../WorkFlows/MobileRechargePlans";
import CircleSelector, {
  BillPlanSelector,
  UbpSummary,
} from "../WorkFlows/BillRecharge";
import LineDivider from "../LineDivider";
import TenureSlider from "../../FeatureComponents/WorkFlows/TenureSlider";
import ManageCreditCard from "../../FeatureComponents/WorkFlows/ManageCreditCard";
import Calendar from "../../FeatureComponents/WorkFlows/Calendar";
import RewardsFeedback from "../CCRewardsFeedback";
import DateTimePicker from "../../FeatureComponents/WorkFlows/DateTimePicker";
import GetAuthenticators from "../../FeatureComponents/WorkFlows/GetAuthenticators";
//snpplus Bot
import SnpPlusPlans from "../WorkFlows/SnpPlusPlans";
//digital Consent Bot
import TermsAndConditions from "../WorkFlows/TermsAndConditions";
import RBLCardSelection from "../WorkFlows/RBLCardSelection";
//Xpress and STPL Bot
import XpressCashPlans, {
  XpressCashPlansForSpecicAmt,
} from "../WorkFlows/XpressCashPlans";
import InputBankDetails from "../WorkFlows/InputBankDetails";
import STPLPlans, { STPLPlansForSpecicAmt } from "../WorkFlows/STPLPlans";
//Snp Bot
import AllTransactionDetails from "../WorkFlows/AllTransactionDetails";
import ComputeEMI, { SelectedEMIDetail } from "../WorkFlows/ComputeEMI";
//CreditRewards
import CreditRewardsStock from "../WorkFlows/CreditRewardsStock";
import CreditRewardsItemDetails from "../WorkFlows/CreditRewardsItemDetails";
//Inactive Bot
import CardBenefits from "../WorkFlows/CardBenefits";
//Block Credit card
import BlockCreditCard from "../WorkFlows/BlockCreditCard";
//offers chatbot
import OffersCategory from "../WorkFlows/OffersCategory";
import OfferImages from "../WorkFlows/OfferImages";

// import CrestPromotion from '../../FeatureComponents/OverlayMessage';
import RegisteredBillers from "../../FeatureComponents/WorkFlows/RegisteredBillers";
import GetUpcommingBills from "../../FeatureComponents/WorkFlows/GetUpcomingBills";
import CCRewardsFeedback from "../CCRewardsFeedback";
import LeadGenForm from "../WorkFlows/LeadGenForm";
import LeadGenAmounts from "../WorkFlows/LeadGenAmount";
import PreClosure from "../WorkFlows/PreClosure";
import DebitCardSettings from "../WorkFlows/DebitCardSettings";

const HandleWorkflowJson = (props) => {
  if (!props.workflowJson.includes("{")) {
    return null;
  }

  try {
    //  console.log(props.workflowJson.replace(/<br>/g, '').replace(/<p>/g, '').replace(/&nbsp;/g, '').replace(/<\/p>/g, ''));
    //  console.log(props.workflowJson);
    var workflowJson = JSON.parse(
      props.workflowJson
        .replace(/<br>/g, "")
        .replace(/<p>/g, "")
        .replace(/&nbsp;/g, "")
        .replace(/<\/p>/g, "")
        .replace(/<h2>/g, "")
        .replace(/<\/h2>/g, "")
    );

    if (typeof workflowJson.responseJson === "string") {
      return workflowJson.responseJson;
    }

    if (workflowJson.hasOwnProperty("mask") && workflowJson.mask === true) {
      document.querySelector(".sf-chatbot #chatInput").classList.add("sf-mask");
      window.changeChatMessages("mask");
    }

    //tenureSlider

    if (workflowJson.hasOwnProperty("tenureSlider")) {
      return <TenureSlider />;
    }

    //manageCreditCard

    if (workflowJson.workflow === "manageCreditCard") {
      // console.log(props.workflowJson);

      return (
        <ManageCreditCard
          cardData={workflowJson.responseJson}
          masterSwitch={workflowJson.masterSwitch}
          {...workflowJson}
        />
      );
    }

    // debitCardSettings

     if (workflowJson.workflow === "debitCardSettings") {
      return (
        <DebitCardSettings
          cardData={workflowJson.responseJson}
          masterSwitch={false}
          {...workflowJson}
        />
      );
    }

    //LeadGenForm
    if (workflowJson.workflow === "leadGenStatesForForm") {
      let formInputFields = workflowJson.form;

      var {
        responseJson: { leadGenStatesForForm },
      } = workflowJson;
      return (
        <LeadGenForm
          leadGenStates={leadGenStatesForForm}
          formInputFields={formInputFields}
        />
      );
    }

    //LeadGenAmount
    if (workflowJson.workflow === "LeadGenAmount") {
      var {
        responseJson: { LeadGenAmount },
      } = workflowJson;

      return <LeadGenAmounts LeadGenAmount={LeadGenAmount} />;
    }

    //DatePicker
    if (workflowJson.hasOwnProperty("showDatePicker")) {
      return <Calendar showRewardCalender={props.showRewardCalender} />;
    }
    //showDateTimePicker
    if (workflowJson.hasOwnProperty("showDateTimePicker")) {
      return <DateTimePicker isPushBotVisible={props.isPushBotVisible} />;
    }

    //showFeedbackStars
    if (workflowJson.hasOwnProperty("showFeedbackStars")) {
      return <RewardsFeedback />;
    }

    //checkBox

    if (workflowJson.hasOwnProperty("checkBox")) {
      return (
        <CheckBox
          checkBoxJsonData={props.checkBoxJsonData}
          checkBoxFlag={props.checkBoxFlag}
          checkBoxButton={workflowJson.button}
          termsCheckBox={props.termsCheckBox}
          termsCheckBoxFlag={props.termsCheckBoxFlag}
          termsText={props.termsText}
          termsLink={props.termsLink}
        />
      );
    }

    //offersImages
    if (workflowJson.workflow === "offersImages") {
      return (
        <OfferImages
          toggleGeneralOverlay={props.toggleGeneralOverlay}
          cardData={workflowJson.categoryOffersList}
        />
      );
    }
    //offersCategory
    if (workflowJson.workflow === "offersCategory") {
      return <OffersCategory cardData={workflowJson.responseJson} />;
    }
    //Block Credit card
    if (workflowJson.workflow === "currentCardSettings") {
      return (
        <BlockCreditCard
          cardData={workflowJson.responseJson}
          masterSwitch={workflowJson.masterSwitch}
        />
      );
    }
    //inactive
    if (workflowJson.workflow === "CardBenefits") {
      return <CardBenefits CardData={workflowJson.responseJson} />;
    }
    //digital Consent
    if (workflowJson.workflow === "DigitalConsentPlan") {
      return (
        <RBLCardSelection
          overlayMessageToggle={props.overlayMessageToggle}
          overlayImageModalToggle={props.overlayImageModalToggle}
          cardData={workflowJson.responseJson}
        />
      );
    }
    if (workflowJson.workflow === "TermsAndConditions") {
      return (
        <TermsAndConditions
          overlayMessageToggle={props.overlayInMessageToggle}
          conditions={workflowJson.responseJson.TermsAndConditions_Text}
        />
      );
    }
    if (workflowJson.workflow === "SnpPlusTenure") {
      return (
        <SnpPlusPlans
          overlayMessageToggle={props.overlayMessageToggle}
          planData={workflowJson.responseJson}
        />
      );
    }
    //XC
    if (workflowJson.workflow === "XpressCashPlans") {
      var {
        responseJson: { planData },
      } = workflowJson;

      return <XpressCashPlans planData={planData} />;
    }
    if (workflowJson.workflow === "XpressCashPlansForSpecicAmt") {
      var {
        responseJson: { planData },
      } = workflowJson;

      return (
        <XpressCashPlansForSpecicAmt
          planData={planData}
          overlayMessageToggle={props.overlayMessageToggle}
        />
      );
    }
    //STPL
    if (workflowJson.workflow === "STPLPlans") {
      var {
        responseJson: { planData },
      } = workflowJson;
      return <STPLPlans planData={planData} />;
    }
    if (workflowJson.workflow === "STPLPlansForSpecicAmt") {
      var {
        responseJson: { planData },
      } = workflowJson;
      return (
        <STPLPlansForSpecicAmt
          planData={planData}
          overlayMessageToggle={props.overlayMessageToggle}
        />
      );
    }
    if (workflowJson.workflow === "findBankDetails") {
      var { responseJson } = workflowJson;
      return (
        <InputBankDetails
          bankDetailData={responseJson}
          overlayMessageToggle={props.overlayMessageToggle}
          overlayIFSCInputToggle={props.overlayIFSCInputToggle}
          userSelectedIFSCCode={props.userSelectedIFSCCode}
          userSelectedBankName={props.userSelectedBankName}
          userSelectedId={props.userSelectedId}
          userSelectedAddress={props.userSelectedAddress}
        />
      );
    }
    //snp
    if (workflowJson.workflow === "SNPALLTRANSACTION") {
      if (workflowJson.responseJson) {
        var {
          responseJson: { transactionsResponse },
        } = workflowJson;
      } else {
        var { transactionsResponse } = workflowJson;
      }
      return (
        <AllTransactionDetails
          transactionsResponse={transactionsResponse}
          overlayMessageToggle={props.overlayMessageToggle}
          logoutUser={props.logoutUser}
          transactionResponseAarry={props.transactionResponseAarry}
          checkList={props.checkList}
          storeChecklist={props.storeChecklist}
        />
      );
    }

    // SNP PRECLOSURE       // DEV 23-12-24
    if (workflowJson.workflow === "snpPreclosure") {
      var preclosure_plan = [];
      preclosure_plan.push(workflowJson);
      return (
        <PreClosure
          SnpComputeEMI={preclosure_plan}
          overlayMessageToggle={props.overlayMessageToggle}
          logoutUser={props.logoutUser}
        />
      );
    }

    if (workflowJson.workflow === "SnpComputeEMI") {
      var {
        responseJson: { transactions_plan },
      } = workflowJson;
      return (
        <ComputeEMI
          SnpComputeEMI={transactions_plan}
          overlayMessageToggle={props.overlayMessageToggle}
          // sessionTimeout={props.sessionTimeout}
          logoutUser={props.logoutUser}
        />
      );
    }
    if (workflowJson.workflow === "SnpEppPlan") {
      var {
        responseJson: { EPP_PlansResponse },
      } = workflowJson;
      return (
        <SelectedEMIDetail
          EPP_PlansResponse={EPP_PlansResponse}
          overlayMessageToggle={props.overlayMessageToggle}
          // sessionTimeout={props.sessionTimeout}
          logoutUser={props.logoutUser}
        />
      );
    }

    //creditRewardsStock

    if (workflowJson.workflow === "creditRewardsStock") {
      if (workflowJson.responseJson) {
        var {
          responseJson: { creditRewardsStock },
        } = workflowJson;
      } else {
        var { creditRewardsStock } = workflowJson;
      }
      return (
        <CreditRewardsStock
          creditRewardsStock={creditRewardsStock}
          overlayMessageToggle={props.overlayMessageToggle}
          checkList={props.checkList}
          storeChecklist={props.storeChecklist}
        />
      );
    }

    //creditRewardsItemDetails

    if (workflowJson.workflow === "creditRewardsItemDetails") {
      var {
        responseJson: { creditRewardsItemDetails },
      } = workflowJson;
      return (
        <CreditRewardsItemDetails
          creditRewardsItemDetails={creditRewardsItemDetails}
          overlayMessageToggle={props.overlayMessageToggle}
        />
      );
    }

    //

    if (workflowJson.workflow === "liabilitiesCheckBookViewAddress") {
      const {
        responseJson: { liabilitiesCheckBookViewAddress },
      } = workflowJson;
      const { cName, cAddress, cZipCode } = liabilitiesCheckBookViewAddress;
      return (
        <div>
          <div style={{ marginBottom: "5px" }}>Registered Address:</div>
          <div>{cName}</div>
          <div>{cAddress}</div>
          <div>Pin: {cZipCode}</div>
          <br />
          <div>
            In case of change in address, please visit the nearest branch and
            update the same. Don't forget to take along a copy of your new
            address proof.
          </div>
          <div
            style={{ marginTop: "5px", fontWeight: 500, fontStyle: "italic" }}
          >
            <b>Note:</b> Your request for Cheque Book will not be processed if
            there are 50 or more / 200 or more unused cheque leaves in Savings /
            Current Account respectively. Please visit your{" "}
            <a target="_blank" href="https://www.rbl.bank.in/locate-branch">
              nearest RBL Bank branch
            </a>{" "}
            for placing the request.
          </div>
          <div
            className="action-elem primary"
            style={{ marginTop: "10px" }}
            onClick={() => autosubmit("Confirm")}
          >
            Confirm
          </div>
        </div>
      );
    }

    if (workflowJson.workflow === "liabilitiesAccounts") {
      var extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question: item.accountNumber,
          type: item.type + " A/C",
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (workflowJson.workflow === "liabilitiesBillPresentment") {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question:
            item["NS1:billerName"] +
            " - " +
            item["NS1:billdetails"]["NS1:billno"] +
            " - " +
            item["NS1:billdetails"]["NS1:billoutstanding"] +
            " - " +
            item["NS1:billdetails"]["NS1:billpaymentdate"],
          value:
            item["NS1:billerName"] +
            " - " +
            item["NS1:billdetails"]["NS1:billno"] +
            " - " +
            item["NS1:billdetails"]["NS1:billoutstanding"] +
            " - " +
            item["NS1:billdetails"]["NS1:billpaymentdate"] +
            "<split>" +
            item["NS1:billdetails"]["NS1:billno"],
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (workflowJson.workflow === "liabilitiesBillPaymentAccounts") {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question: item.account,
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (
      workflowJson.workflow === "liabilitiesGetAllDeposits" ||
      workflowJson.workflow === "liabilitiesGetAllCrestAccounts" ||
      workflowJson.workflow === "liabilitiesGetCardsForAccount"
    ) {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question: item.accountNo,
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (
      workflowJson.workflow === "liabilitiesWithInBankFromAccountsArray" ||
      workflowJson.workflow === "liabilitiesOutsideBankFromAccountsArray" ||
      workflowJson.workflow === "liabilitiesFromAccountsArray" ||
      workflowJson.workflow === "liabilitiesToAccountsArray"
    ) {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question: item.custAccountNumber,
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (
      workflowJson.workflow === "liabilitiesWithInBankBeneficiaryList" ||
      workflowJson.workflow === "liabilitiesOutsideBankBeneficiaryList"
    ) {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question:
            item.beneficiaryName + " / " + item.beneficiaryAccountNumber,
          value: item.beneficiaryAccountNumber,
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (workflowJson.workflow === "creditCardOptSearchStatement") {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question: item.date,
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (workflowJson.workflow === "liabilitiesGetFDScheme") {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question: item.TypeofFD,
          value: item.TypeofFD + "<split>" + item.code,
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (workflowJson.workflow === "liabilitiesGetRDScheme") {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question: item.TypeofFD,
          value: item.TypeofFD + "<split>" + item.schemeCode,
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (workflowJson.workflow === "creditCardMiniStatement") {
      var {
        responseJson: { creditCardMiniStatement },
      } = workflowJson;
      return (
        <CreditCardMiniStatementDetails
          creditCardMiniStatement={creditCardMiniStatement}
        />
      );
    }
    //here *****************************************************************************************************

    //   creditCardStatementsDetails
    if (workflowJson.workflow === "creditCardStatementsDetails") {
      var {
        responseJson: { creditCardStatementsDetails },
      } = workflowJson;
      // console.log(props.setWorkflowName)
      return (
        <CreditCardStatement
          creditCardStatementDetails={creditCardStatementsDetails}
          flag={workflowJson.hide}
          setWorkflowName={props.setWorkflowName}
        />
      );
    }

    //   StatementDetailsForLastPayment
    if (workflowJson.workflow === "StatementDetailsForLastPayment") {
      var {
        responseJson: { StatementDetailsForLastPayment },
      } = workflowJson;
      return (
        <StatementDetailForLastPayment
          statementDetailsForLastPayment={StatementDetailsForLastPayment}
        />
      );
    }

    //   StatementDetailsForStatementCycle
    if (workflowJson.workflow === "StatementDetailsForStatementCycle") {
      var {
        responseJson: { StatementDetailsForStatementCycle },
      } = workflowJson;
      return (
        <StatementDetailForStatementCycle
          statementDetailsForStatementCycle={StatementDetailsForStatementCycle}
        />
      );
    }

    //   StatementDetailsForTotalOutstanding
    if (workflowJson.workflow === "StatementDetailsForTotalOutstanding") {
      var {
        responseJson: { StatementDetailsForTotalOutstanding },
      } = workflowJson;
      return (
        <StatementDetailForOutstanding
          statementDetailsForOutstanding={StatementDetailsForTotalOutstanding}
        />
      );
    }

    //   StatementDetailsForMinAmoutDue
    if (workflowJson.workflow === "StatementDetailsForMinAmoutDue") {
      var {
        responseJson: { StatementDetailsForMinAmoutDue },
      } = workflowJson;
      return (
        <StatementDetailForMinAmoutDue
          statementDetailsForMinAmoutDue={StatementDetailsForMinAmoutDue}
        />
      );
    }
    //   StatementDetailsForPaymentDetails
    if (workflowJson.workflow === "StatementDetailsForPaymentDetails") {
      var {
        responseJson: { StatementDetailsForPaymentDetails },
      } = workflowJson;
      return (
        <StatementDetailForPaymentDetails
          statementDetailsForPaymentDetails={StatementDetailsForPaymentDetails}
        />
      );
    }
    //
    if (workflowJson.workflow === "lastPaymentDetails") {
      var {
        responseJson: { lastPaymentDetails },
      } = workflowJson;
      return <LastPaymentStatement lastPaymentDetails={lastPaymentDetails} />;
    }

    if (workflowJson.workflow === "creditCardGetTotalCreditLimit") {
      var {
        responseJson: { creditCardGetTotalCreditLimit },
      } = workflowJson;
      return (
        <CreditCardGetTotalCreditLimit data={creditCardGetTotalCreditLimit} />
      );
    }

    if (workflowJson.workflow === "creditCardGetAvailableCreditLimit") {
      var {
        responseJson: { creditCardGetAvailableCreditLimit },
      } = workflowJson;
      return (
        <CreditCardGetAvailableCreditLimit
          data={creditCardGetAvailableCreditLimit}
        />
      );
    }

    if (
      workflowJson.workflow === "getDebitCard" ||
      workflowJson.workflow === "getCreditCard"
    ) {
      let extras = [],
        { responseJson } = workflowJson;
      responseJson[workflowJson.workflow].forEach(function (item) {
        extras.push({
          question: item.cardNumber,
          mask: true,
          value: item.cardNumber,
        });
      });
      return (
        <ExtraDisambInfos handleSubmit={props.handleSubmit} extras={extras} />
      );
    }

    if (workflowJson.workflow === "liabilitiesAccountBalance") {
      var {
        responseJson: { liabilitiesAccountBalance },
      } = workflowJson;
      return (
        <AccountBalance liabilitiesAccountBalance={liabilitiesAccountBalance} />
      );
    }
    if (workflowJson.workflow === "liabilitiesAccountSummary") {
      var {
        responseJson: { liabilitiesAccountSummary },
      } = workflowJson;
      return (
        <AccountSummary liabilitiesAccountSummary={liabilitiesAccountSummary} />
      );
    }
    if (workflowJson.workflow === "liabilitiesMiniStatement") {
      var {
        responseJson: { liabilitiesMiniStatement },
      } = workflowJson;
      return (
        <MiniStatementDetails
          liabilitiesMiniStatement={liabilitiesMiniStatement}
        />
      );
    }
    if (workflowJson.workflow === "liabilitiesTransactionHistory") {
      var {
        responseJson: { liabilitiesTransactionHistory },
      } = workflowJson;
      return (
        <TransactionHistoryDetails
          liabilitiesTransactionHistory={liabilitiesTransactionHistory}
        />
      );
    }
    if (workflowJson.workflow === "downloadFile") {
      var {
        responseJson: {
          downloadFile: { pdfFile },
        },
      } = workflowJson;
      downloadPDFData(pdfFile);
      window.changeChatMessages("downloadFile");
    }
    if (workflowJson.workflow === "liabilitiesGetMobilePrepaidBillers") {
      var {
        responseJson: { liabilitiesGetMobilePrepaidBillers },
      } = workflowJson;
      return (
        <div className="recharge-billers">
          {liabilitiesGetMobilePrepaidBillers.map(
            ({ billerId, billerLogo, billerName }) => {
              return (
                <img
                  key={billerId}
                  onClick={() => {
                    window["autosubmit"](billerId);
                  }}
                  src={billerLogo}
                  alt={billerName}
                  style={{
                    width: "70px",
                    margin: "10px",
                    cursor: "pointer",
                    boxShadow: "0 0 7px rgba(0,0,0,0.1)",
                  }}
                />
              );
            }
          )}
        </div>
      );
    }
    if (workflowJson.workflow === "liabilitiesGetCircleNames") {
      var {
        responseJson: { liabilitiesGetCircleNames },
      } = workflowJson;
      return (
        <CircleSelector liabilitiesGetCircleNames={liabilitiesGetCircleNames} />
      );
    }
    if (workflowJson.workflow === "liabilitiesIFSCSearch") {
      var {
        responseJson: { liabilitiesIFSCSearch },
      } = workflowJson;
      return <IFSCSelector liabilitiesIFSCSearch={liabilitiesIFSCSearch} />;
    }

    //TransactionDetails

    if (workflowJson.workflow === "TransactionDetails") {
      var {
        responseJson: { TransactionDetails },
      } = workflowJson;

      return (
        <CreditCardTransactionDetails TransactionDetails={TransactionDetails} />
      );
    }

    //CreditCardRewards

    if (workflowJson.workflow === "CreditCard_Rewards") {
      var {
        responseJson: { CreditCard_Rewards },
      } = workflowJson;
      return <CreditCardRewards CreditCard_Rewards={CreditCard_Rewards} />;
    }

    //creditCardOrderId

    if (workflowJson.workflow === "creditCardOrderId") {
      var {
        responseJson: { creditCardOrderId },
      } = workflowJson;
      return <CreditCardOrderId creditCardOrderId={creditCardOrderId} />;
    }

    //UPB ***liabilitiesGetBillerCategories***/

    if (workflowJson.workflow === "liabilitiesGetBillerCategories") {
      var {
        responseJson: { liabilitiesGetBillerCategories },
      } = workflowJson;
      return (
        <BillerRegion
          liabilitiesGetBillerCategories={liabilitiesGetBillerCategories}
          placeholder="Please select the category"
        />
      );
    }
    //liabilitiesGetAuthenticators
    if (workflowJson.workflow === "liabilitiesGetAuthenticators") {
      var {
        responseJson: { liabilitiesGetAuthenticators },
      } = workflowJson;
      return (
        <GetAuthenticators
          liabilitiesGetAuthenticators={liabilitiesGetAuthenticators}
        />
      );
    }
    //
    if (workflowJson.workflow === "getLocations") {
      var {
        responseJson: { getLocations },
      } = workflowJson;
      return <LocationList locations={getLocations}></LocationList>;
    }

    if(workflowJson.workflow === "creditCardBillingCycle") {
      var {
        responseJson: { creditCardBillingCycle },
      } = workflowJson;
      return (
        <CreditCardBillingCycle creditCardBillingCycle={creditCardBillingCycle}/>
      )
    }

    //insert here**********Add Nominee Input (relation type/country/state/city)**************************************
    if (
      workflowJson.workflow === "liabilitiesFetchDetailsNomineeRelationType"
    ) {
      var {
        responseJson: { liabilitiesFetchDetailsNomineeRelationType },
      } = workflowJson;
      return (
        <NomineeRelation
          NomineeRelationType={liabilitiesFetchDetailsNomineeRelationType}
        ></NomineeRelation>
      );
    }

    if (workflowJson.workflow === "liabilitiesFetchDetailsNomineeCountry") {
      var {
        responseJson: { liabilitiesFetchDetailsNomineeCountry },
      } = workflowJson;
      return (
        <NomineeCountry
          NomineeCountryType={liabilitiesFetchDetailsNomineeCountry}
        ></NomineeCountry>
      );
    }

    if (workflowJson.workflow === "liabilitiesFetchDetailsNomineeState") {
      var {
        responseJson: { liabilitiesFetchDetailsNomineeState },
      } = workflowJson;
      return (
        <NomineeState
          NomineeStateType={liabilitiesFetchDetailsNomineeState}
        ></NomineeState>
      );
    }

    if (workflowJson.workflow === "HomeLoanLeadGenCity") {
      var {
        responseJson: { HomeLoanLeadGenCity },
      } = workflowJson;
      return (
        <HomeLoanCity HomeLoanCityNames={HomeLoanLeadGenCity}></HomeLoanCity>
      );
    }

    if (workflowJson.workflow === "liabilitiesFetchDetailsNomineeCity") {
      var {
        responseJson: { liabilitiesFetchDetailsNomineeCity },
      } = workflowJson;
      return (
        <NomineeCity
          NomineeCityType={liabilitiesFetchDetailsNomineeCity}
        ></NomineeCity>
      );
    }

    if (workflowJson.workflow === "liabilitiesFetchDetailsGuardianCode") {
      var {
        responseJson: { liabilitiesFetchDetailsGuardianCode },
      } = workflowJson;
      return (
        <GuardianCode
          liabilitiesFetchDetailsGuardianCode={
            liabilitiesFetchDetailsGuardianCode
          }
        ></GuardianCode>
      );
    }
    //LeadGenStates & LeadGenCities
    if (workflowJson.workflow === "leadGenStates") {
      var {
        responseJson: { leadGenStates },
      } = workflowJson;
      return <LeadGenStates leadGenStates={leadGenStates}></LeadGenStates>;
    }
    if (workflowJson.workflow === "leadGenCities") {
      var {
        responseJson: { leadGenCities },
      } = workflowJson;
      return <LeadGenCities leadGenCities={leadGenCities}></LeadGenCities>;
    }

    //liabilitiesTurnover
    if (workflowJson.workflow === "liabilitiesTurnover") {
      var {
        responseJson: { liabilitiesTurnover },
      } = workflowJson;

      return <Turnover liabilitiesTurnover={liabilitiesTurnover}></Turnover>;
    }
    //leadGenCountriesISDCodes
    if (workflowJson.workflow === "leadGenCountriesISDCodes") {
      var {
        responseJson: { leadGenCountriesISDCodes },
      } = workflowJson;

      return (
        <LeadGenCountries
          leadGenCountriesISDCodes={leadGenCountriesISDCodes}
        ></LeadGenCountries>
      );
    }

    //here BBPS billers ****

    if (workflowJson.workflow === "liabilitiesGetBillers") {
      var {
        responseJson: { liabilitiesGetBillers },
      } = workflowJson;

      // {props.setBbpsBiller(liabilitiesGetBillers[0].ISBILLERBBPS)}

      return <BillerName liabilitiesGetBillers={liabilitiesGetBillers} />;
    }
    if (workflowJson.workflow === "liabilitiesViewBillerAccount") {
      var {
        responseJson: { liabilitiesViewBillerAccount },
      } = workflowJson;
      return (
        <BillerAccount
          liabilitiesGetBillers={liabilitiesViewBillerAccount}
          DeleteBillerName
        />
      );
    }
    //UPB liabilitiesGetRechargePlans*** /
    if (workflowJson.workflow === "liabilitiesGetRechargePlans") {
      var {
        responseJson: { liabilitiesGetRechargePlans },
      } = workflowJson;
      return (
        <BillPlanSelector
          liabilitiesGetRechargePlans={liabilitiesGetRechargePlans}
          overlayRechargeToggle={props.overlayRechargeToggle}
          handleSubmit={props.handleSubmit}
        />
      );
    }
    //UBPSummary
    if (workflowJson.workflow === "liabilitiesUbpSummary") {
      var {
        responseJson: { liabilitiesUbpSummary },
      } = workflowJson;
      return (
        <UbpSummary
          liabilitiesUbpSummary={liabilitiesUbpSummary}
          NoConfirmButton={props.NoConfirmButton}
        />
      );
    }
    //BillPaymentSummary

    if (workflowJson.workflow === "makeBillPayment") {
      var {
        responseJson: { makeBillPayment },
      } = workflowJson;
      return (
        <BillPaymentSummary
          makeBillPayment={makeBillPayment}
          BbpsFlag={props.BbpsFlag}
        />
      );
    }

    // getRegisteredBillers

    if (workflowJson.workflow === "getRegisteredBillers") {
      var {
        responseJson: { getRegisteredBillers },
      } = workflowJson;
      return <RegisteredBillers getRegisteredBillers={getRegisteredBillers} />;
    }
    //GetUpcommingBills
    if (workflowJson.workflow === "getUpcommingBills") {
      var {
        responseJson: { getUpcommingBills },
      } = workflowJson;
      return <GetUpcommingBills getUpcommingBills={getUpcommingBills} />;
    }

    //
    if (workflowJson.workflow === "Location_Finder") {
      var { Location_Finder } = workflowJson;
      return Location_Finder.map(
        ({ address, ifsc, distance, directionURL }, i) => {
          return (
            <div key={i} className="nearest-atm-branch-block">
              <div>{address}</div>
              {ifsc == "" ? null : <div>IFSC Code - {ifsc}</div>}
              <div>{distance}</div>
              <div>
                {" "}
                <a href={directionURL} target="_blank">
                  Direction on Google Maps
                </a>
              </div>
              {i !== Location_Finder.length - 1 && <LineDivider />}
            </div>
          );
        }
      );
    }
  } catch (error) {
    console.error(error);
    // return <div>Oops! It’s not you. It’s us. Give it another try later, please.</div>;
    return (
      <div>Sorry! Something went wrong. Please try again after sometime.</div>
    );
  }
  return null;
};

export default HandleWorkflowJson;
